import branditRails from '../../../../api/brandit_rails'
import {
  clearIntegrationsErrorsAction,
  setIntegrationsErrorsAction,
  setIntegrationsDataAction,
  setIntegrationsStatusAction
} from './integrations.actions'

/**
 * Fetch portal core integrations
 * @returns {(dispatch: import('redux').Dispatch) => Promise<void>}
 */
export const fetchIntegrations = () => async dispatch => {
  try {
    dispatch(setIntegrationsStatusAction('loading'))
    dispatch(clearIntegrationsErrorsAction())

    const { data } = await branditRails.get('/integrations')

    dispatch(setIntegrationsDataAction(data))
    dispatch(setIntegrationsStatusAction('succeeded'))
  } catch (err) {
    dispatch(setIntegrationsStatusAction('failed'))
    dispatch(
      setIntegrationsErrorsAction({
        action: 'fetchIntegrations',
        message: err.message || err.response?.data?.message || 'Failed to fetch integrations'
      })
    )
  }
}
